


















import { Vue, Component } from "vue-property-decorator";
import FinalDocumentForm from "@/components/final-document/FinalDocumentForm.vue";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";

@Component({ components: { CBreadCrumbs, FinalDocumentForm } })
export default class FinalDocumentNew extends Vue {
  get breadcrumbs() {
    return [
      {
        to: { name: "finalDocumentList" },
        label: `${this.$tc(this.$translate.FinalDocuments)}`
      },
      {
        label: this.$tc(this.$translate.Create)
      }
    ];
  }
}
